import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import QuestionCircle from '../../assets/dashboard/QuestionCircle';

function InfoTooltip({ placement = 'bottom', content, className, icon = <QuestionCircle /> }) {
  return (
    <>
      <OverlayTrigger placement={placement} overlay={<Tooltip>{content}</Tooltip>}>
        <div
          className={`${
            className ?? 'd-flex px-2 align-items-center justify-content-center cursor-pointer'
          }`}
        >
          {icon}
        </div>
      </OverlayTrigger>
    </>
  );
}

export default InfoTooltip;
